import { useEffect, useState } from "react";
import ProductionOrderService from "../../../../../services/Production/ProductionOrderService";
import DataTableComponentsPO from "./DataTableComponentsPO";
import withLoader from "../../../../../components/layouts/WithLoader";
import { TextField } from "@material-ui/core";
import getCurrentUserId from "../../../../../reduxSaga/sagas/requests/currentUserId";
import { useNavigate } from "react-router-dom";
import UtilsFormule from "../../../../../utils/UtilsFormule";
import { Modal, Button } from "react-bootstrap"; // Import Modal from react-bootstrap

const ProductionOrderDetails = ({ startLoading, stopLoading }) => {
  const [productionOrder, setProductionOrder] = useState(null);
  const [scheduledDate, setScheduledDate] = useState(null);
  const [showModal, setShowModal] = useState(false); // State to manage modal visibility
  const [isDisabled,setIsDisabled]=useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    startLoading();
    ProductionOrderService.getPOById(localStorage.getItem("idPO"))
      .then((response) => {
        console.log("getPOById", response.data.success);
        setProductionOrder(response.data.success);
        stopLoading();
      })
      .catch(() => {
        alert("problème de connexion");
      });
  }, []);

  const generateWorkOrder = async () => {
    try {
      setShowModal(true); // Affiche le modal lorsque le processus commence
     
      setIsDisabled(true)
      const utilisateurId = getCurrentUserId();
      const ordreDeProductionId = localStorage.getItem("idPO");

      if (!utilisateurId || !ordreDeProductionId || !scheduledDate) {
        console.error("Données manquantes pour créer les ordres de travail.");
        setShowModal(false);
        return;
      }

      await ProductionOrderService.createWorkOrdersfromProductionOrder(
        utilisateurId,
        ordreDeProductionId,
        scheduledDate
      );

      console.log("Ordre de travail généré avec succès.");
    } catch (error) {
      console.error("Erreur lors de la génération de l'ordre de travail :", error);
      setShowModal(false); // Cache le modal à la fin du processus
    } finally {
      setShowModal(false); // Cache le modal à la fin du processus
    }
  };


  const onChangeScheduledDate = (event) => {
    setScheduledDate(event.target.value.concat(":59"));
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <div className="row">
                <div className="col-sm-9">
                  <h3 className="card-title">L'ordre de production : </h3>{" "}
                  {productionOrder && productionOrder.code}{" "}
                  {productionOrder && productionOrder.name}
                </div>
                <div className="col-sm-3">
                  Date limite :{" "}
                  {productionOrder && UtilsFormule.formatDateHours(productionOrder.scheduledDate)}
                </div>
              </div>
            </div>
            <div className="card-body">
              {productionOrder && (
                <DataTableComponentsPO
                  listComponents={productionOrder.components}
                />
              )}
            </div>
            {productionOrder && productionOrder.state === "SAVED" && (
              <div className="card-footer">
                <div className="row">
                  <div className="col-sm-8">
                    <div className="form-group">
                      <label htmlFor="inputName">Scheduled date</label>
                      <TextField
                        style={{ width: "100%" }}
                        className="col-sm-12"
                        variant="outlined"
                        value={scheduledDate}
                        onChange={onChangeScheduledDate}
                        id="datetime-local"
                        type="datetime-local"
                        defaultValue="date"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        size="small"
                      />
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <br />
                    <button
                      className="btn btn-dark float-right"
                      disabled={isDisabled}
                      onClick={generateWorkOrder}
                    >
                      Générer Les bons de travail
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Modal to show process progress */}
      <Modal show={showModal} onHide={() => setShowModal(false)} backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title>Traitement en cours</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Votre demande est en cours de traitement. Cela peut prendre entre 15 et 20 minutes.
          Vous retrouverez votre ordre de production dans la page "Les ordres de production" une fois le traitement terminé.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowModal(false)
            navigate("/production-orders")
          }}>
            Fermer
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default withLoader(ProductionOrderDetails);
